<template>
    <div>
        <canvas ref="canvas" :height="height"></canvas>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    name: 'PieChart',

    props: {
        labels: { type: Array, default: () => [] },
        data: { type: Array, default: () => [] },
        colors: { type: Array, default: () => [] },
        height: { type: Number, default: 220 },
        doughnut: { type: Boolean, default: false },
        currency: { type: Boolean, default: true },
    },

    data: () => ({
        chart: null,
    }),

    mounted() {
        this.render();
    },

    beforeDestroy() {
        if (this.chart) this.chart.destroy();
    },

    watch: {
        labels() { this.render(); },
        data() { this.render(); },
        colors() { this.render(); },
    },

    methods: {
        render() {
            if (this.chart) this.chart.destroy();
            const ctx = this.$refs.canvas;
            if (!ctx) return;

            const fmtCurrency = (v) => 'R$ ' + Number(v).toFixed(2);

            this.chart = new Chart(ctx, {
                type: this.doughnut ? 'doughnut' : 'pie',
                data: {
                    labels: this.labels,
                    datasets: [{
                        data: this.data,
                        backgroundColor: this.colors.length ? this.colors : this.defaultPalette(this.data.length),
                        borderWidth: 1,
                    }],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: { position: 'right' },
                    tooltips: this.currency ? {
                        callbacks: {
                            label: (item, chartData) => {
                                const label = chartData.labels[item.index];
                                const value = chartData.datasets[0].data[item.index];
                                return `${label}: ${fmtCurrency(value)}`;
                            },
                        },
                    } : {},
                },
            });
        },

        defaultPalette(n) {
            const base = [
                '#1976D2', '#9C27B0', '#FF9800', '#4CAF50', '#F44336',
                '#00BCD4', '#FFC107', '#3F51B5', '#E91E63', '#8BC34A',
            ];
            const out = [];
            for (let i = 0; i < n; i++) out.push(base[i % base.length]);
            return out;
        },
    },
};
</script>
